module.exports = __webpack_public_path__ + "assets/media/cascade1.81fb3356.mp4";